/**
 * Implementation of Login URL verification
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React, { FormEvent, ReactNode, useEffect, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  useExchangeAccessToken,
  useGetCurrentUser,
  useUpdateUserName,
} from "../../../api/reactQuery";
import useQuery from "../../../hooks/useQuery";

export default function Verify() {
  const [name, setName] = useState("");
  const queryParams = useQuery();
  const navigate = useNavigate();

  const currentUser = useGetCurrentUser(false);
  
  const { isLoading, isError, error, data } = useExchangeAccessToken(
    { loginToken: queryParams.get('secret') || '', userId: queryParams.get('userId') || '' },
    // () => currentUser.refetch()
    (data:any) => localStorage.setItem("@userToken", data.token)
  );


  const {
    mutate: updateUser,
    isLoading: updateUserLoading,
    error: updateUserError,
  } = useUpdateUserName();

  function _handleNameUpdate(e: FormEvent) {
    e.preventDefault();

    updateUser(
      name,
      { onSuccess: () => navigate("/dashboard/home", { replace: true }) }
    );
  }

  if (isLoading || currentUser.isLoading)
    return (
      <div className="flex justify-center items-center">
        <BiLoaderAlt className="animate-spin" size={42} />
      </div>
    );

  if (isError)
    return (
      <div className="flex justify-center items center">
        <h1 className="text-center text-2xl mb-5">
          Oops! Something went wrong!
        </h1>
        <p className="text-center">{error as string}</p>
      </div>
    );

  // @ts-ignore
  return  !(data?.user?.name) ? (
    <>
      <h1 className="text-center text-2xl mb-4">Enter your name</h1>
      <form onSubmit={_handleNameUpdate}>
        <input
          className="px-4 py-3 rounded-lg bg-gray-200 w-full my-2 outline-none border border-transparent focus:border-primary"
          placeholder="John Doe"
          required
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
        {updateUserLoading ? (
          <div className="flex justify-center items-center">
            <BiLoaderAlt className="animate-spin" size={28} />
          </div>
        ) : (
          <button className="btn-accent mt-1.5 w-full">Submit</button>
        )}
        {updateUserError && <p>{updateUserError as ReactNode}</p>}
      </form>
    </>
  ) : (
    <Navigate to="/dashboard/home" replace />
  );
}
